import { useQuery } from '@tanstack/react-query';
import { getSeatsCharts, SeatsChartsResponse } from 'services/Seats';

export const useGetSeatsCharts = () => {
	const { data, isLoading, error, refetch } = useQuery({
		queryKey: ['seats-charts'],
		queryFn: (): Promise<SeatsChartsResponse> => getSeatsCharts(),
	});

	return {
		data: data?.items || [],
		isLoading,
		error,
		refetch,
	};
};
